import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import viewsGlobalcompnent from './components';
import common from './common';
import './permission';
import {Notify, Lazyload} from 'vant';
import {Toast} from 'vant';
import globalMixin from './utils/globalMixin';
import './filters'; // global filters
import moment from 'moment';
import lodash from 'lodash';
import 'moment/locale/zh-cn';
import '@/style/animate.less'
// 全局注册

Vue.use(Lazyload);
Vue.use(Notify);
Vue.use(Toast);
Vue.mixin(globalMixin);
Vue.use(viewsGlobalcompnent);
// Vue.use(VueLodash, { lodash: lodash });

Vue.prototype.common = common;
Vue.prototype._ = _;
Vue.prototype.$moment = moment;
Vue.config.productionTip = false;

moment.locale('zh-cn');
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
Vue.directive('realname-check', {
    // 当元素与指令绑定时调用
    bind(el, binding, vnode) {
        // 这里可以添加检查用户是否实名的逻辑
        // const userIsRealName = checkIfUserIsRealName(); // 假设checkIfUserIsRealName()是检查实名的函数

        if (store.getters.userInfo.realcheck == 3) {
            // 如果用户已实名，则绑定一个点击事件处理程序
            el.addEventListener('click', binding.value);
        } else {
            // 如果用户未实名，则阻止点击事件
            el.addEventListener('click', (event) => {
                Toast('先请完成实名');
                event.preventDefault();
                event.stopPropagation();
            });
        }
    },
});
